<template>
  <recipe-view :client="client" :favorites-client="favoritesClient" />
</template>

<script lang="ts">
  import RecipeView from '@/views/recipe/RecipeView.vue';
  import { useAuthStore } from '@/stores/auth';
  import RecipeClient from '@/service/recipe/recipeClient';
  import { defineComponent } from 'vue';
  import { useFirestore } from 'vuefire';
  import FavoritesClient from '@/service/favorites/favoritesClient';

  export default defineComponent({
    name: 'RecipeViewRoute',
    components: { RecipeView },
    async setup() {
      const authStore = useAuthStore();
      const favoritesClient = new FavoritesClient(
        useFirestore(),
        authStore.getIdentifier().uid,
      );
      const client = await RecipeClient.setup(authStore.getIdentifier());
      return { client, favoritesClient };
    },
  });
</script>

<style scoped></style>
